import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const WHATSAPP_NUMBER = "994776030335";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Salam, Albazar.az hesabıma balans (AZN) yükləmək istəyirəm.",
)}`;

export type PromoPlan = "vip" | "premium";

export const PROMO_DURATIONS = [
  { days: 1, price: 1, label: "1 gün" },
  { days: 7, price: 5, label: "7 gün" },
  { days: 30, price: 20, label: "30 gün" },
] as const;

export const PROMO_PRICES: Record<PromoPlan, Record<number, number>> = {
  vip: { 1: 1, 7: 5, 30: 20 },
  premium: { 1: 2, 7: 10, 30: 30 },
};

export function promoPrice(plan: PromoPlan, days: number) {
  return PROMO_PRICES[plan]?.[days] ?? 0;
}

export function formatAzn(value: number) {
  return `${Number(value ?? 0).toFixed(2)} AZN`;
}

export async function fetchMyBalance(userId: string) {
  const { data, error } = await supabase
    .from("profiles")
    .select("balance")
    .eq("id", userId)
    .maybeSingle();
  if (error) throw error;
  return Number(data?.balance ?? 0);
}

export function useBalance(userId?: string) {
  return useQuery({
    queryKey: ["balance", userId],
    enabled: Boolean(userId),
    queryFn: () => fetchMyBalance(userId as string),
  });
}

export async function fetchMyTransactions(userId: string) {
  const { data, error } = await supabase
    .from("transactions")
    .select("id, amount, kind, status, method, note, created_at")
    .eq("user_id", userId)
    .order("created_at", { ascending: false })
    .limit(50);
  if (error) throw error;
  return data ?? [];
}

export async function purchasePromotion(listingId: string, plan: PromoPlan, days: number) {
  const { data, error } = await (
    supabase.rpc as unknown as (
      fn: string,
      args: Record<string, unknown>,
    ) => Promise<{ data: number | null; error: { message: string } | null }>
  )("purchase_promotion", { _listing_id: listingId, _plan: plan, _days: days });
  if (error) throw new Error(error.message);
  return Number(data ?? 0);
}